import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Router } from "react-router-dom";
import { LanguageProvider } from "./containers/LanguageContext";
import * as serviceWorker from "./serviceWorker";
import { createBrowserHistory } from "history";
import ScrollTop from "./components/ScrollTop";

const history = createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    <LanguageProvider>
      <ScrollTop />
      <App />
    </LanguageProvider>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
